import React from "react";
import PageBanner from "../components/PageBanner";
import Sidebar from "../components/Sidebar";
import { PAGE_BANNERS } from "../data/content";
import { ExternalLink } from "lucide-react";

export default function OrderSupplements() {
  return (
    <div>
      <PageBanner src={PAGE_BANNERS.clinic} alt="Order Supplements" fallbackKey="clinic" />
      <div className="flex flex-col lg:flex-row gap-8">
        <Sidebar />
        <article className="flex-1 nn-content">
          <h1>Order Supplements</h1>
          <p>
            Patients of Nourish Natural Health Clinic can order professional-grade supplements
            through our trusted dispensary partner.
          </p>
          <a
            href="https://www.emersonecologics.com/CustomOrder.aspx?RefID=00183766"
            target="_blank"
            rel="noreferrer"
            className="nn-cream-btn inline-flex items-center gap-2 px-6 py-3 font-display tracking-wider mt-4"
          >
            Buy Products <ExternalLink className="w-4 h-4" />
          </a>
        </article>
      </div>
    </div>
  );
}
